import { render, staticRenderFns } from "./ContactUS.vue?vue&type=template&id=f2951ae8&scoped=true&"
import script from "./ContactUS.vue?vue&type=script&lang=js&"
export * from "./ContactUS.vue?vue&type=script&lang=js&"
import style0 from "./ContactUS.vue?vue&type=style&index=0&id=f2951ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2951ae8",
  null
  
)

export default component.exports